import { Box, Progress as ChakraProgress, Text, Flex } from "@chakra-ui/react";

type ProgressProps = {
  text: string;
  percentage?: number;
};

export const Progress = ({ text, percentage }: ProgressProps) => {
  const value = percentage ?? 0;

  return (
    <Box width="100%">
      <Flex justify="space-between" align="center" mb={2}>
        <Text fontSize="md">{text}</Text>
        <Text fontSize="sm" color="gray.500">
          {value.toFixed(2)}%
        </Text>
      </Flex>
      <ChakraProgress value={value} size="md" borderRadius="md" />
    </Box>
  );
};
